import { render, staticRenderFns } from "./HomeSanteEnfant.vue?vue&type=template&id=46fa8e97&scoped=true&"
import script from "./HomeSanteEnfant.vue?vue&type=script&lang=ts&"
export * from "./HomeSanteEnfant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa8e97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
